import React from 'react'
import { get } from 'lodash'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import RichText from './RichText'

const Body = (props) => (
  <Box my={8}>
    <Container maxWidth="md">
      <RichText
        locale={get(props, 'node_locale')}
        json={get(
          props,
          'body.json',
          get(props, 'content.json')
        )}
      />
    </Container>
  </Box>
)

export default Body
